// 虚拟仓库存调整

import TableList from "@components/templates/tablelist";
import { HttpVirlWarehouse } from "@/service/allotment";
import { mapGetters } from "vuex";
import comIndex from './update'

export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_errorType: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpVirlWarehouse,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'allotvirtualwarehouseUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'allotvirtualwarehouseUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "allotvirtualwarehouseUpdate",
                        params: { type: "query" },
                        query: { id: params},
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'exportExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/inventory/changeOrder/export', this.formData, 'download');
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary',['getVirtualWareList',]),
        ToolsData() {
            return [
                {
                    label: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    label: "导出",
                    operate: "exportExcel",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "调整单号",
                    tag: 'vInput',
                    key: 'EQ_changeOrderNo',
                    show: true,
                },
                {
                    label: "虚拟仓",
                    tag: 'vSelect',
                    key: 'EQ_inventoryChangeOrderEntity.orgWarehouseId',
                    options: this.getVirtualWareList,
                    show: true,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_sku',
                    show: true,

                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [
            {
                title: '调整单号',
                key: 'changeOrderNo',
                render:(h,{row})=>{
                    return <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.changeOrderId, 'query')}>{row.changeOrderNo}</a>
                            <a onClick={this.handleOperates.bind(this, row.changeOrderId, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    </div>
                }
            },
            {
                title: '虚拟仓',
                key: 'orgWarehouseId',
                render: (h, { row }) => this.findRenderLabel(this.getVirtualWareList, row.orgWarehouseId),
            },
            {
                title: 'ERPSKU',
                key: 'sku',
            },
            {
                title: '调整前库存',
                key: 'currentQty',
            },
            {
                title: '调整后库存',
                key: 'qty',
            },
            {
                title: '调整原因',
                key: 'remark',
            },
            {
                title: '操作人',
                key: 'createdName',
            },
            {
                title: '创建日期',
                key: 'createdAt',
                sortable: true
            },
            ];
        },

    },

};
